import React, { useEffect } from "react";
import { createContext, ReactNode, useContext, useState } from "react";
import { CartEntity, CouponData, AddressData, AddressesEntity } from "../../models/cartData";
import { cartOperations, fetchAPIData, getCart, getCartV2, getDATA, getResponse } from "../../services/cart/cart";
import { createCheckout, createCheckoutV2 } from "../../services/checkout/checkout";
import Cookies from "js-cookie";
import { Navigate } from "react-router-dom";
import { pushCartItem, viewCartEvent } from "../../utils/GoogleAnalytics";


interface cartdataProps {
    data: CartEntity[]
}

interface cartCouponProps {
    data: CouponData
}

interface addressDataProps {
    data: AddressesEntity[]
}

interface statusProps {
    status: string | any
}
interface checkoutStatusProps {
    checkoutOpen: boolean | any
}


type ShoppingCartProviderProps = {
    children: ReactNode
}

interface PopupContextProps {
    isPopup: boolean;
    popupId: string | null;
}


interface saveAddrressProps {
    status: boolean;
    message: string;
}



interface CartItemInterface {
    item_name: string;
    item_id: number;
    index: number;
    item_brand: string;
    item_category?: string;
    item_category2?: string;
    item_category3?: string;
    power_type?: string;
    sph_left_eye_power?: number;
    sph_right_eye_power?: number;
    left_eye_boxes?: number;
    right_eye_boxes?: number;
    additional_left_eye_power?: number;
    additional_right_eye_power?: number;
    cyl_left_eye_power?: number;
    cyl_right_eye_power?: number;
    axis_left_eye?: number;
    axis_right_eye?: number;
    item_list_id?: number;
    item_list_name?: string;
    item_variant?: string;
    price?: number;
    quantity?: number;
  }
type ShoppingCartContext = {
    updateCartItem: (payload: any) => void
    fetchCart: () => any
    getCartData: cartdataProps | null | undefined
    gerCartError: any
    setError: () => void
    getCouponData: cartCouponProps | null | undefined
    applyCod: (payload: any) => void
    removeCod: (payload: any) => void
    applyWallet: (payload: any) => void
    removeWallet: (payload: any) => void
    removeCartItem: (payload: any) => void
    applyGold: (payload: any) => void
    removeGold: (payload: any) => void
    getCustomerAddresses: () => void
    getDeliveryDate: (sku: any, pin: any) => void
    getCustomerAddressData: addressDataProps | null | undefined
    pinCodeData: addressDataProps | null | undefined
    getCustomerCoupons: () => void
    emptyCart: (id:any) => void
    applyCoupon: (id: any, coupon: any) => void
    removeCoupon: (payload: any) => void
    statusData: any
    isCartLoadingData: any
    setAddressToggleData:any
    pageData: any
    modalOpenData: any
    isClickData: any
    tokenData: any
    setPageData: (payload: any) => void
    handleClick: (payload: any) => any
    setBearerToken: (payload: any) => void
    setLoader: (payload: any) => void
    handleSetCheckedAddress: (payload: any) => void
    setAddressToggle: (payload: any) => void
    handleModal: (payload: any) => void
    // checkoutStatus: boolean | any
    openPopup: (popupId: string) => void;
    closePopup: () => void;
    handleAddNewAddress: () => void
    handleEditAddress: (payload: any) => void
    selectedAddressData: any
    checkedAddressData: any
    // isPopup: boolean;
    // popupId: string | null;
    updateCustomerAddress: (payload: any) => void
    saveAddressData: any
    applyAddress: (id: any, address_id: any) => void
    

}

type CartItem = {
    id: number,
    quantity: number

}

const ShoppingCartContext = createContext<ShoppingCartContext>({
    updateCartItem: () => { },
    fetchCart: () => { },
    getCartData: null,
    gerCartError: null,
    setError: () => { },
    getCouponData: null,
    getCustomerAddressData: null,
    pinCodeData: null,
    applyCod: () => { },
    removeCod: () => { },
    applyWallet: () => { },
    removeWallet: () => { },
    removeCartItem: () => { },
    applyGold: () => { },
    removeGold: () => { },
    getCustomerAddresses: () => { },
    getDeliveryDate: () => { },
    getCustomerCoupons: () => { },
    emptyCart: () => { },
    applyCoupon: () => { },
    removeCoupon: () => { },
    statusData: null,
    isCartLoadingData: null,
    setAddressToggleData:null,
    pageData: null,
    modalOpenData: null,
    isClickData: null,
    tokenData: null,
    setPageData: () => { },
    setBearerToken: () => { },
    setLoader: () => { },
    handleSetCheckedAddress: () => { },
    setAddressToggle: () => { },
    handleModal: () => { },
    handleClick: () => { },
    // checkoutStatus: false
    openPopup: () => { },
    closePopup: () => { },
    handleAddNewAddress: () => { },
    handleEditAddress: () => { },
    selectedAddressData: null,
    checkedAddressData: null,
    updateCustomerAddress: () => { },
    saveAddressData: null,
    applyAddress: () => { }



});


export function useShoppingCart() {
    return useContext(ShoppingCartContext);
}



export function ShoppingCartProvider({ children }: ShoppingCartProviderProps) {
    const [cartData, setCartData] = useState<cartdataProps | null>()
    const [couponData, setCouponData] = useState<cartCouponProps | null>()
    const [addressData, setAddressData] = useState<addressDataProps | null>()
    const [status, setStatus] = useState('loading');
    const [errorMsg, setErrorMsg] = useState();
    const [checkoutOpen, setCheckoutOpen] = useState(false);
    const [page, setPage] = useState(1);
    const [token, setToken] = useState('');

    const [isCartLoading, setIsCartLoading] = useState(false);
    const [isError, setIsError] = useState('');

    const [checkedAddress, setCheckedAddress] = useState<number | null>(null);

    // const [isLoading, setisLoading] = useState(false);
    // Api Error 
    function setError() {
        setIsError('');
    }


    const cookieValue = Cookies.get('cookieName');
    let tokenData: any | string | undefined ;
    tokenData = cookieValue
    // console.log(tokenData,'cart token data');

    const handleRefresh = () => {
        window.location.reload();
    };
    

    // Fetch Cart
    function fetchCart() {
        return getCart("app/api/v2/cart")
            .then((response) => {
                if (response.length > 0) {
                    // console.log(response, 'fetch cart');
                    setCartData({ data: response })
                    setStatus('success')
                    setIsError('');
                                   
                    const tempCartItems = response[0]?.temp_cart_items;
                    let cart_item_array:any = [];
                    const cartItemsEvent = pushCartItem(tempCartItems, cart_item_array);                  
                    viewCartEvent(cartItemsEvent);
                    return { data: response };
       
                }
                else {
                    // console.log(response.response.data.message, 'get cart  error');
                    // let error = response.response.data.message;
                    let error = 'Something Went Wrong!';
                    setIsError(error);
                    setStatus('failed')
                    // if(tokenData === undefined){
                    // handleRefresh();
                    // } else {
                    //     setIsError(error);
                    //     setStatus('failed')
                    // }
                   
                    return;
                }
            })
            .catch((error) => {
                setStatus("failed");
                setErrorMsg(error.msg);
                // console.log(error)
            });
    }



    // update cart Item ( increase quantity)
    function updateCartItem(payload: any) {
        setIsCartLoading(true);
        // console.log(status)
        cartOperations("app/api/v2/cart/item/update", payload).then((response: any) => {
            if (response.length > 0) {
                // console.log(response, 'cartUpdated');   
                setCartData({ data: response });
                setIsCartLoading(false);
                setStatus('success')
                getCustomerCoupons();
                // console.log(status)
                // console.log(cartData,'updateCartItem');
            }else {
                // console.log(response.response.data.message, 'update cart item error');
                let error = response.response.data.message;
                setIsError(error);
                setIsCartLoading(false);
                setStatus('failed')
                return;
            }

        })
            .catch((error) => {
                setIsCartLoading(false);
                setErrorMsg(error.msg);
                // console.log(error)
            });

    }

    // update cart Item ( decrease quantity)

    function removeCartItem(payload: any) {
        // console.log('removeCartItem')
        setIsCartLoading(true);

        cartOperations("app/api/v2/cart/item/remove", payload).then((response: any) => {
            if (response.length > 0) {
                // console.log(response, 'item removed');
                setCartData({ data: response });
                setIsCartLoading(false);
                setStatus('success')
                getCustomerCoupons();
                // console.log(cartData,'updateCartItem');
            }else{
                // console.log(response.response.data.message, 'get cart  error');
                let error = response.response.data.message;
                setIsError(error);
                setIsCartLoading(false);
                setStatus('failed')
                return;

            }

        })
            .catch((error) => {
                setIsCartLoading(false);
                setErrorMsg(error.msg);
                // console.log(error)
            });


    }

    // apply Gold from cart first time 

    function applyGold(payload: any) {
        // console.log('applyGold')
        setIsCartLoading(true);
        cartOperations("app/api/v2/cart/gold/apply", payload).then((response: any) => {
            if (response.length > 0) {
                // console.log(response, 'gold added');
                setCartData({ data: response });
                setIsCartLoading(false);
                setStatus('success')

                // console.log(cartData,'updateCartItem');
            }else{
                // console.log(response.response.data.message, 'get cart  error');
                let error = response.response.data.message;
                setIsError(error);
                setIsCartLoading(false);
                setStatus('failed')

                return;
            }

        })
            .catch((error) => {
                setIsCartLoading(false);
                setErrorMsg(error.msg);
                // console.log(error)
            });

    }

    //  remove gold from cart 

    function removeGold(payload: any) {
        // console.log('removeGold')
        setIsCartLoading(true);


        cartOperations("app/api/v2/cart/gold/remove", payload).then((response: any) => {
            if (response.length > 0) {
                // console.log(response, 'item removed');
                setCartData({ data: response });
                setIsCartLoading(false);
                setStatus('success')
                // console.log(cartData,'updateCartItem');
            }else{
                // console.log(response.response.data.message, 'get cart  error');
                let error = response.response.data.message;
                setIsError(error);
                setIsCartLoading(false);
                setStatus('failed')
                return;
            }

        })
            .catch((error) => {
                setIsCartLoading(false);
                setErrorMsg(error.msg);
                // console.log(error)
            });

    }


    // get Customer address List if any 
    function getCustomerAddresses() {
        // console.log('getCustomerAddresses')
        getDATA("app/api/v1/customer/addresses").then((response: any) => {
            if (response) {
                // console.log(response, 'getCustomerAddresses');
                // console.log(cartData,'updateCartItem');
                setAddressData({ data: response })

                // Filter the default address (assuming is_default is a boolean or number field)
            const defaultAddress = response.find((item: any) => item.is_default === 1);
            // console.log(defaultAddress,defaultAddress.id,'dfgdg')
            if (defaultAddress) {
                // Perform operations with the default address if needed
                // console.log('Default Address:', defaultAddress);
                setCheckedAddress(defaultAddress.id)
            }
            }

        })
            .catch((error) => {

                setErrorMsg(error.msg);
                // console.log(error)
            });

    }


    function handleSetCheckedAddress(payload:any){
        setCheckedAddress(payload)
    }


    // Estimated delivery time according to pin code
    const [isPinData, setIsPinData] = useState<any>();

    function getDeliveryDate(sku: any, pincode: any) {
        getResponse("app/api/v1/customer/addresses").then((response: any) => {
            if (response) {
                // console.log(response, 'getPinData');
                // console.log(cartData,'updateCartItem');
                setIsPinData({ data: response })
            }

        })
            .catch((error) => {
                setErrorMsg(error.msg);
                // console.log(error)
            });

    }




    // post api

    // apply cash on delivery
    function applyCod(payload: React.ChangeEvent<HTMLInputElement>) {
        // console.log('applcod')
        setIsCartLoading(true);


        cartOperations("app/api/v2/cart/cod/apply", payload).then((response) => {
            if (response) {
                // console.log(response, 'cod added');
                setCartData({ data: response })
                setIsCartLoading(false);

                // setShopifyOrder({ShopifyOrder : response})
            }
        })
            .catch((error) => {
                setErrorMsg(error.msg);
                // console.log(error)
            });
    }

    // remove cash on delivery

    function removeCod(payload: React.ChangeEvent<HTMLInputElement>) {
        // console.log('applcod')
        setIsCartLoading(true);

        cartOperations("app/api/v2/cart/cod/remove", payload).then((response: any) => {
            if (response) {
                // console.log('cod remove');
                setCartData({ data: response })
                setIsCartLoading(false);

                // setShopifyOrder({ShopifyOrder : response})
            }
        })
            .catch((error) => {

                setErrorMsg(error.msg);
                // console.log(error)
            });
    }

    // Apply aquacash in cart 

    function applyWallet(payload: React.ChangeEvent<HTMLInputElement>) {
        // console.log('apply Wallet')
        setIsCartLoading(true);

        cartOperations("app/api/v2/cart/wallet/apply", payload).then((response) => {
            if (response) {
                // console.log(response, 'cod added');
                setCartData({ data: response })
                setIsCartLoading(false);

                // setShopifyOrder({ShopifyOrder : response})
            }
        })
            .catch((error) => {
                setErrorMsg(error.msg);
                // console.log(error)
            });
    }

    // Remove Aquacash in cart
    function removeWallet(payload: React.ChangeEvent<HTMLInputElement>) {
        // console.log('remove Wallet')
        setIsCartLoading(true);

        cartOperations("app/api/v2/cart/wallet/remove", payload).then((response: any) => {
            if (response) {
                // console.log('cod remove');
                setCartData({ data: response })
                setIsCartLoading(false);

                // setShopifyOrder({ShopifyOrder : response})
            }
        })
            .catch((error) => {
                setErrorMsg(error.msg);
                // console.log(error)
            });
    }

    // Apply coupon to the cart

    function applyCoupon(cart_id: any, coupon: any) {
        setIsCartLoading(true);
        let payload = {
            'cart_id': cart_id,
            'coupon': coupon
        }
        // console.log('applyCoupon')

        cartOperations("app/api/v2/cart/coupon/apply", payload).then((response) => {
            if (response.length > 0) {
                // console.log(response, 'Coupon Added');
                setCartData({ data: response })
                setIsError('');
                setIsCartLoading(false);
                closePopup();
                

                // setShopifyOrder({ShopifyOrder : response})
            } else {
                // console.log(response.response.data.message, 'Coupon Added error');
                let error = response.response.data.message;
                setIsError(error);
                setIsCartLoading(false);
                return;
            }
        })
            .catch((error) => {
                setIsCartLoading(false);
                setErrorMsg(error.msg);
                
            });
    }


    // remove Coupon from the cart
    function removeCoupon(cart_id: any) {
        setIsCartLoading(true);
        let payload = {
            'cart_id': cart_id
        }
        // console.log('coupon Remove')
        cartOperations("app/api/v2/cart/coupon/remove", payload).then((response) => {
            if (response.length > 0) {
                // console.log(response, 'Coupon removed');
                setCartData({ data: response })
                setIsCartLoading(false);


                // setShopifyOrder({ShopifyOrder : response})
            }else{
                // console.log(response.response.data.message, 'Coupon Added error');
                let error = response.response.data.message;
                setIsError(error);
                setIsCartLoading(false);
                return;
            }
        })
            .catch((error) => {
                setStatus("failed");
                setErrorMsg(error.msg);
                // console.log(error)
            });
    }


    // fetch List of coupons
    function getCustomerCoupons() {
        // setStatus("loading");

        createCheckoutV2("app/v2/customer/coupons").then((response: any) => {
            if (response) {
                setCouponData({ data: response });
                // console.log(response);
            }
        })
            .catch((error: any) => console.log(error));
    }


    // set page Id which popup is opened its will be identify by id
    function setPageData(id: any) {
        setPage(id);
    }

    // set beared token 
    function setBearerToken(payload: any) {
        setToken(payload);
    }



    // ripple effect on click of button 
    const [rippleStyle, setRippleStyle] = useState({});
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        const button = event.currentTarget;
        const { offsetX, offsetY } = event.nativeEvent;
        const size = Math.max(button.offsetWidth, button.offsetHeight);
        const rippleX = offsetX - size / 2;
        const rippleY = offsetY - size / 2;

        setRippleStyle({
            left: rippleX + 'px',
            top: rippleY + 'px',
            width: size + 'px',
            height: size + 'px'
        });
    };


    // const [modalOpen, setModalOpen] = useState(false);
    //  handle modal and back button  with id 
    function handleModal(payload: any) {
        setModalOpen(payload);
    }
    const [modalOpen, setModalOpen] = useState<PopupContextProps>({ isPopup: false, popupId: null });

    const openPopup = (popupId: string) => {
        setModalOpen({ isPopup: true, popupId });
    }
    const closePopup = () => {
        setModalOpen({ isPopup: false, popupId: null });
    }

    //  form , to add new address  
    const handleClickAddressForm = () => {
        // console.log('address Form')
        openPopup('addressForm');
    };

    const handleClickAddressList = () => {
        // console.log('address two three')
        openPopup('address');
    };

    const [selectedAddress, setSelectedAddress] = useState(null);

    const handleAddNewAddress = () => {
        setSelectedAddress(null); // Clear the selected address
        handleClickAddressForm();
    };

    const handleEditAddress = (address: any) => {
        // console.log(address,'sdfghjkl');
        setSelectedAddress(address);
        handleClickAddressForm();
    };

    // to Add new Address
    const [saveAddress, setSaveAddress] = useState<saveAddrressProps>()


    const data = cartData;
    const cart_id = data?.data[0].id;

    function updateCustomerAddress(payload: any) {
        setIsCartLoading(true);
        fetchAPIData("app/api/v1/customer/address/update", payload).then((response) => {
            if (response.status === true) {
                console.log(response,'update address');
                setSaveAddress(response)
                closePopup();
                handleClickAddressList();
                getCustomerAddresses();
                setIsCartLoading(false);
                setIsError('');
                fetchCart();

            }else {
                // console.log(response.response.data.message, 'error address error');
                let error = response.response.data.message;
                setIsError(error);
                setIsCartLoading(false);
                return;
            }
        })
            .catch((error) => {
                setErrorMsg(error.msg);
                // console.log(error)
            });
    }

    // to Apply address 
    function applyAddress(cart_id: number, address_id: number) {
        setIsCartLoading(true);
        let payload = {
            'cart_id': cart_id,
            'address_id': address_id
        }
        cartOperations("app/api/v2/cart/address/apply", payload).then((response) => {
            if (response.length > 0) {
                closePopup();
                // console.log(response, 'Address Added');
                setCartData({ data: response })
                setIsCartLoading(false);
                setIsError('');
            }else{
                // console.log(response.response.data.message, 'error address error');
                let error = response.response.data.message;
                setIsError(error);
                setIsCartLoading(false);
                return;
            }
        })
            .catch((error) => {
                setStatus("failed");
                setErrorMsg(error.msg);
                // console.log(error)
            });

    }

    // to set loader
    function setLoader(payload: any) {
        setStatus(payload);
    }


    const [isAddressFetched, setIsAddressFetched] = useState(false);

    function setAddressToggle(flag:boolean){
        setIsAddressFetched(flag)
    }



    // empty cart
    function emptyCart(id: any) {
        // setStatus("loading");
        getCart("/app/api/v2/cart/empty").then((response: any) => {
            if (response) {
                console.log(response);
                // console.log(response);
            }
        })
            .catch((error: any) => console.log(error));
    }









    return (
        <ShoppingCartContext.Provider
            value={{
                statusData: status,
                setLoader,
                handleSetCheckedAddress,
                setPageData,
                setBearerToken,
                tokenData: token,
                pageData: page,
                updateCartItem,
                removeCartItem,
                applyGold,
                removeGold,
                getCustomerAddresses,
                getCustomerAddressData: addressData,
                getDeliveryDate,
                pinCodeData: isPinData,
                fetchCart,
                getCartData: cartData,
                gerCartError: isError,
                setError,
                applyCod,
                removeCod,
                getCustomerCoupons,
                getCouponData: couponData,
                applyCoupon,
                removeCoupon,
                applyWallet,
                removeWallet,
                // checkoutStatus: checkoutOpen,
                handleClick,
                isClickData: rippleStyle,
                handleModal,
                modalOpenData: modalOpen,
                closePopup,
                openPopup,
                handleAddNewAddress,
                handleEditAddress,
                selectedAddressData: selectedAddress,
                updateCustomerAddress,
                saveAddressData: saveAddress,
                applyAddress,
                isCartLoadingData: isCartLoading,
                setAddressToggleData:isAddressFetched,
                setAddressToggle,
                emptyCart,
                checkedAddressData:checkedAddress

            }}>
            {children}
        </ShoppingCartContext.Provider>
    )
}



